import { ApiCall } from '../ApiClient';
import { ResultData, UserLiteData, WorkspaceData, WorkspaceDetailData, WorkspaceLiteData } from '../ApiTypes';
import { dateTransformer } from '../ApiUtil';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

const list = () => get<WorkspaceDetailData[]>({
    path: '/workspaces.list',
    transform: dateTransformer(),
});

const info = (workspaceId: string) => get<WorkspaceData>({
    path: '/workspaces.info',
    query: { workspaceId },
    transform: dateTransformer(),
});

const infoLite = (workspaceId: string) => get<WorkspaceLiteData>({
    path: '/workspaces.info',
    query: { workspaceId, lite: true },
    transform: dateTransformer(),
});

type CreateBody = { label: string, description: string, addSelf: boolean, type?: string, makePublic?: boolean };
const create = (body: CreateBody) => post<WorkspaceLiteData>({
    path: '/workspaces.create', body
});

type DeleteBody = { workspaceId: string };
const de1ete = (body: DeleteBody) => post<ResultData>({
    path: '/workspaces.delete', body
});

type UpdateBody = { workspaceId: string, label?: string, description?: string, public?: boolean };
const update = (body: UpdateBody) => post<WorkspaceLiteData>({
    path: '/workspaces.update', body
});

const membersList = (workspaceId: string) => get<UserLiteData[]>({
    path: '/workspaces.members.list',
    query: { workspaceId },
    transform: dateTransformer(),
});

type MembersAddBody = { workspaceId: string, values: string[] };
const membersAdd = (body: MembersAddBody) => post<UserLiteData[]>({
    path: '/workspaces.members.add', body
});

type MembersInviteBody = { workspaceId: string, idsAndEmails: string[] };
const membersInvite = (body: MembersInviteBody) => post<{ ok: boolean }>({
    path: '/workspaces.members.invite', body
});

type MembersRemoveBody = { workspaceId: string, userIds: string[] };
const membersRemove = (body: MembersRemoveBody) => post<ResultData>({
    path: '/workspaces.members.remove', body
});

type JoinBody = { workspaceId: string, userId?: string };
const join = (body: JoinBody) => post<WorkspaceLiteData>({
    path: '/workspaces.join', body
});

type LeaveBody = { workspaceId: string, userId?: string };
const leave = (body: LeaveBody) => post<ResultData>({
    path: '/workspaces.leave', body
});

export const workspacesEndpoints = {
    list,
    info,
    infoLite,
    members: {
        list: membersList,
        add: membersAdd,
        invite: membersInvite,
        remove: membersRemove,
    },
    create,
    de1ete,
    update,
    join,
    leave,
};
